module.exports = __webpack_public_path__ + "static/media/design.6ee84a17.jpg";